import type { InventoryStatus } from '@/types/inventory';

// Colours used by the Inventory page's status column; statuses not listed fall back to grey.
const statusStyles: Partial<Record<InventoryStatus, string>> = {
  Active: 'bg-green-900 text-green-200',
  Picked: 'bg-blue-900 text-blue-200',
  Damaged: 'bg-red-900 text-red-200',
};

interface InventoryStatusBadgeProps {
  status: InventoryStatus;
  title?: string;
  /** Visually hidden prefix read before the status by screen readers, e.g. "Inventory status". */
  srLabel?: string;
}

export function InventoryStatusBadge({ status, title, srLabel }: InventoryStatusBadgeProps) {
  return (
    <span className={`px-2 py-1 text-xs rounded ${statusStyles[status] ?? 'bg-gray-700 text-gray-400'}`} title={title}>
      {srLabel && <span className="sr-only">{srLabel}: </span>}
      {status}
    </span>
  );
}
